<svg
	fill="none"
	stroke="currentColor"
	viewBox="0 0 24 24"
	width="100%"
	height="100%"
	xmlns="http://www.w3.org/2000/svg"
	aria-hidden="true"
	stroke-width="2"
	stroke-linecap="round"
	stroke-linejoin="round"
>
	<path
		stroke-linecap="round"
		stroke-linejoin="round"
		d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
	/>
</svg>
